// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aaaeG","top":"styles_top__VdiQF"};